import Page from "../Page";

export function Contact() {
    return <Page header="Contact Us">
        <p>TODO...</p>
    </Page>
}